import { MutationTuple, useMutation } from '@apollo/client';
import { RejectWeldInput, RejectWeldPayload } from '@bechtel/types';
import { REJECT_WELD } from '@bechtel/client-gql';

export function useRejectWeld(
  onActionCompleted?: () => void,
  refetchQueries?: string[]
): MutationTuple<{ rejectWeldPayload: RejectWeldPayload }, { input: RejectWeldInput }> {
  const response = useMutation<{ rejectWeldPayload: RejectWeldPayload }, { input: RejectWeldInput }>(REJECT_WELD, {
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      if (onActionCompleted) onActionCompleted();
    },
    onError: () => {
      if (onActionCompleted) onActionCompleted();
    },
    refetchQueries,
  });
  return response;
}
